import { useEffect, useState } from 'react';

export default <T>(value: T, delay = 300): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebounced(value), delay);
    return () => {
      clearTimeout(timeout);
    };
  }, [value, delay]);

  return debounced;
};
